module.exports = __webpack_public_path__ + "media/images/it/amazon-card-9ff3966f980b4192bf1e0bc69fdfae62.png";